import Alpine from "alpinejs";
import "@/wap/main.css";

window.Alpine = Alpine;

Alpine.data('carousel', () => ({
  activeSlide: 1,
  slides: [
    {
      image: require("./assets/aqua-cleaner-items-1.webp"),
      title: "Bico Extrator Grande",
    },
    {
      image: require("./assets/aqua-cleaner-items-2.webp"),
      title: "Bico Extrator Pequeno",
    },
    {
      image: require("./assets/aqua-cleaner-items-3.webp"),
      title: "Bico Múltiplo com Escova",
    },
    {
      image: require("./assets/aqua-cleaner-items-4.webp"),
      title: "Filtro Espuma",
    },
    {
      image: require("./assets/aqua-cleaner-items-5.webp"),
      title: "Bico Escova",
    },
    {
      image: require("./assets/aqua-cleaner-items-6.webp"),
      title: "Extensão Telescópica em Alumínio",
    },
    {
      image: require("./assets/aqua-cleaner-items-7.webp"),
      title: "Rodo Removível",
    },
    {
      image: require("./assets/aqua-cleaner-items-8.webp"),
      title: "Bico Canto",
    },
    {
      image: require("./assets/aqua-cleaner-items-9.webp"),
      title: "Mangueira de 2,3m com Gatilho Spray",
    },
  ],
  previous() {
    if (this.activeSlide > 1) {
      this.activeSlide -= 1;
    } else {
      this.activeSlide = this.slides.length;
    }
  },
  next() {
    if (this.activeSlide < this.slides.length) {
      this.activeSlide += 1;
    } else {
      this.activeSlide = 1;
    }
  },
}));

// Swiper
const swiperEl = document.querySelector("swiper-container");
const swiperParams = {
  slidesPerView: 1,
  slidesPerGroup: 1,
  pagination: false,
  loop: true,
  breakpoints: {
    640: {
      slidesPerView: 2,
      slidesPerGroup: 2,
      pagination: false,
    },
    1024: {
      slidesPerView: 3,
      slidesPerGroup: 3,
      pagination: false,
    },
  },
  injectStyles: [
    `
      .swiper-button-next,
      .swiper-button-prev {
        background-color: rgb(210 213 219);
        padding: 8px 16px;
        border-radius: 100%;
        border: 0;
        color: white;
      }
      .swiper-button-next {
        padding-left: 18px;
      }
      .swiper-button-prev {
        padding-right: 18px;
      }
      .swiper-button-next > svg,
      .swiper-button-prev > svg {
        transform: scale(0.65);
      }
  `,
    // .swiper-pagination {
    //   top: 16px !important;
    //   bottom: auto !important;
    // }
    // .swiper-pagination-bullet {
    //   border-radius: 3px;
    //   width: 16px;
    //   height: 3px;
    //   background-color: rgb(151 155 163);
    // }
  ],
  on: {
    init() {
      // ...
    },
  },
};
Object.assign(swiperEl, swiperParams);
if (swiperEl) swiperEl.initialize();

Alpine.start();

let interval;

function sendHeight() {
  if (document.getElementById("lp")) {
    const height = document.body.scrollHeight;
    window.parent.postMessage({ frameHeight: height }, "*");
  } else {
    clearInterval(interval);
    interval = null;
  }
}

// Send the height when the DOM is fully loaded
document.addEventListener("DOMContentLoaded", sendHeight);

// Update the height at an interval
interval = setInterval(sendHeight, 500);

// Optionally, update the height when the window is resized
window.addEventListener("resize", sendHeight);